module.exports = {};


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-polyfill/~/core-js/modules/_iterators.js
// module id = 128
// module chunks = 0